module.exports = __webpack_public_path__ + "static/media/dhnanajay.5a2fa4ca.png";